import React, { useState, useEffect } from "react";
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import moment from 'moment';
import Icon from "./icons";
import { useStoreBrnDSSelector } from "../store/selectors/userSelector";

interface FilterProps {
    onApplyFilter: (filters: { source: string; maxRating: number; dateRange: { startDate: Date | null; endDate: Date | null } }) => void;
    onClearFilter: () => void;
    filterClass: string;
}

const Filter: React.FC<FilterProps> = ({ onApplyFilter, onClearFilter, filterClass }) => {
    // console.log(useStoreBrnDSSelector());
    // States to hold filter values
    const [isOpen, setIsOpen] = useState(true);
    const [source, setSource] = useState('');
    const [keyword, setKeyword] = useState('');
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);
    const [filterValue, setFilterValue] = useState<any>({})
    const [minValue, setMinValue] = useState(1);
    const [maxValue, setMaxValue] = useState(5);

    useEffect(() => {
        const currentDate = new Date();

        const prevDate = currentDate.setDate(currentDate.getDate() - 30);
        const formattedPrevDate = moment(prevDate).format('YYYY-MM-DD');
        setStartDate(formattedPrevDate);
        const formattedCurrDate = moment(currentDate).format('YYYY-MM-DD');
        setStartDate(formattedCurrDate);
    }, []);

    const handleToggleAccordion = () => setIsOpen(!isOpen);

    const handleDateChange = (dateRange: any | Date) => {
        if (dateRange) {
            const [start, end] = dateRange;
            setStartDate(moment(start).format('YYYY-MM-DD'));
            setEndDate(moment(end).format('YYYY-MM-DD'));
        }
    };

    const applyFilter = () => {
        console.log(minValue, maxValue);
        let filter: any = {}
        if (source && source !== 'all') {
            filter.source = source;
        }
        if (keyword) {
            filter.keyword = keyword;
        }
        if (startDate) {
            filter.start_date = startDate;
        }

        if (endDate) {
            filter.end_date = endDate;
        }
        if (maxValue && minValue) {
            filter.max_rating = maxValue;
            filter.min_rating = minValue;
        }

        onApplyFilter(filter);

    };

    const clearFilter = () => {
        setSource('');
        setKeyword('');
        setStartDate(null);
        setEndDate(null);
        setMaxValue(5);
        setMinValue(1);
        onClearFilter();
    }


    const marks = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        // 6: '6',
        // 7: '7',
        // 8: '8',
        // 9: '9',
        // 10: '10',
    };

    return (
        <div className={filterClass}>
            <div className="border-b mb-4">
                <button
                    onClick={handleToggleAccordion}
                    className="w-full text-left py-3 px-4 bg-gray-200 rounded-md text-gray-600 font-semibold flex justify-between items-center"
                >
                    Filter
                    <span className="ml-2">{useStoreBrnDSSelector()?.branch_name}</span>
                </button>

                {/*-----------------filter-accordion----------------- */}
                {isOpen && (
                    <div className="p-4 bg-gray-50 max-h-auto">
                        {/* Filter Row */}

                        {/* Source Filter (Single Row) */}
                        <div className="mb-5 relative">
                            <label htmlFor="source" className="block text-sm text-gray-600 mb-2">Source</label>
                            <select
                                id="source"
                                value={source == '' ? 'all' : source}
                                onChange={(e) => setSource(e.target.value)}
                                className="block w-full p-2 rounded-md bg-white text-sm text-gray-900 outline outline-1 -outline-offset-1 focus:outline-2 focus:outline-blue-600 sm:text-sm"
                                style={{
                                    appearance: 'none',
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    backgroundImage: 'none',
                                }}
                            >
                                <option value="" disabled className="text-gray-400">Source</option>
                                <option value="all" className="text-gray-400">All</option>
                                <option value="yelp" className="text-gray-500">Yelp</option>
                                <option value="google" className="text-gray-500">Google</option>
                                <option value="resy" className="text-gray-500">Resy</option>
                            </select>
                            <Icon name="arrow-down" size={20} className="absolute right-[12px] top-[46px] transform -translate-y-1/2 text-gray-400" />
                        </div>

                        {/* Date Range Filter (Single Row) */}
                        <div className="mb-5">
                            <label className="block text-sm text-gray-600">Date Range</label>
                            <DateRangePicker
                                className="block-lg w-full p-2 rounded-md -ml-[5px]"
                                onChange={handleDateChange}
                                format="yyyy-MM-dd"
                                showOneCalendar
                                value={[startDate ? new Date(startDate) : new Date(), endDate ? new Date(endDate) : new Date()]}
                            />
                        </div>

                        {/* Star Rating Filter (Single Row) */}
                        {/* <div className="mb-5">
                            <label className="block text-sm text-gray-600 mb-2">Star Rating</label>
                            <Slider
                                min={1}
                                max={10}
                                value={maxRating}
                                onChange={(value) => setMaxRating(Array.isArray(value) ? value[0] : value)}
                                railStyle={{ backgroundColor: '#ddd' }}
                                trackStyle={{ backgroundColor: '#4f46e5' }}
                                handleStyle={{
                                    borderColor: '#4f46e5',
                                    backgroundColor: '#fff',
                                    height: 16,
                                    width: 16,
                                }}
                                marks={{
                                    1: '1',
                                    2: '2',
                                    3: '3',
                                    4: '4',
                                    5: '5',
                                    6: '6',
                                    7: '7',
                                    8: '8',
                                    9: '9',
                                    10: '10',
                                }}
                            />
                        </div> */}
                        <div className="mb-5">
                            <label className="block text-sm text-gray-600 mb-3">Rating</label>
                            <Slider
                                range
                                min={1} // Minimum value
                                max={5} // Maximum value
                                step={1} // Step size
                                value={[minValue, maxValue]} // Set the initial values for min and max
                                onChange={(value: number | number[]) => {
                                    if (Array.isArray(value)) {
                                        setMinValue(value[0]);
                                        setMaxValue(value[1]);
                                    }
                                }}
                                marks={marks} // Define the marks on the slider
                                railStyle={{
                                    backgroundColor: '#ddd',
                                    height: '6px',
                                    borderRadius: '3px',
                                }}
                                trackStyle={{
                                    backgroundColor: '#4f46e5',
                                    height: '6px',
                                    borderRadius: '3px',
                                }}
                                handleStyle={{
                                    backgroundColor: '#4f46e5',
                                    border: '2px solid white',
                                    height: '16px',
                                    width: '16px',
                                    borderRadius: '50%',
                                }}
                            />
                        </div>


                        {/* Apply Button */}
                        <div className="flex space-x-4 mt-12">
                            <button
                                onClick={applyFilter}
                                className="py-2 px-3 bg-blue-600 rounded-md text-white font-semibold w-full"
                            >
                                Apply
                            </button>
                            <button
                                onClick={clearFilter}
                                className="py-2 px-3 bg-red-500 rounded-md text-white font-semibold w-full"
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Filter;
